import type { ResizableSidebarLayoutProps } from "./ResizableSidebarLayout";
import { ResizableSidebarLayout } from "./ResizableSidebarLayout";

export type CollapsibleSidebarProps = ResizableSidebarLayoutProps;

export function CollapsibleSidebar(props: CollapsibleSidebarProps) {
    return <ResizableSidebarLayout {...props} />;
}
